import { Stack } from "@chakra-ui/react";
import OfferingTable from "./offeringTable";
import ServerConfig from "./serverConfig";
import { SectionDivider } from "app/components/shared/SectionDivider";

const Offerings = () => {
  return (
    <Stack data-cy="section-offerings">
      <SectionDivider padding={"2.25rem 0"} label={"Ansible Offering"} />
      <OfferingTable />
      <ServerConfig />
    </Stack>
  );
};

export default Offerings;
